exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".copy-board{text-align:center}.copy-board .modal-body{min-height:350px}.copy-board input{border:1px solid #0c2d39}.copy-board .picker{margin-bottom:20px}.copy-board .picker>div{margin-top:20px}.copy-board .datepicker-input .vdp-datepicker__calendar{margin:0 auto}.copy-board .datepicker-input header{color:#000!important;background-color:#fff!important}.copy-board .datepicker-input header .next,.copy-board .datepicker-input header .prev{display:inline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4d35d76d","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Board/Copy.vue
// module id = 435
// module chunks = 0